<template>
  <PlatformDetailPage type="asset" />
</template>

<script>
import PlatformDetailPage from '../components/reference/PlatformDetailPage'

export default {
  name: 'ResourcePage',
  components: { PlatformDetailPage }
}
</script>
